// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseTable-module__font-s-10___xQLlf {
  font-size: 10px !important;
}

.BaseTable-module__font-s-12___PPO1E {
  font-size: 12px !important;
}

.BaseTable-module__font-s-13___iLU1R {
  font-size: 13px !important;
}

.BaseTable-module__font-s-14___aDOtc {
  font-size: 14px !important;
}

.BaseTable-module__font-s-15___rV_ly {
  font-size: 15px !important;
}

.BaseTable-module__font-s-16___AfkeJ {
  font-size: 16px !important;
}

.BaseTable-module__font-s-18___kN0Jj {
  font-size: 18px !important;
}

.BaseTable-module__font-s-20___cAnZi {
  font-size: 20px !important;
}

.BaseTable-module__font-s-22___VKqTB {
  font-size: 22px !important;
}

.BaseTable-module__font-s-28___bFhcm {
  font-size: 28px !important;
}

.BaseTable-module__font-w-400___y2ef6 {
  font-weight: 400 !important;
}

.BaseTable-module__font-w-500___QRuId {
  font-weight: 500 !important;
}

.BaseTable-module__font-w-600___pdYsj {
  font-weight: 600 !important;
}

.BaseTable-module__font-w-700___GHReb {
  font-weight: 700 !important;
}

.BaseTable-module__p-5___uYjxR {
  padding: 5px !important;
}

.BaseTable-module__p-12___hgcEg {
  padding: 12px !important;
}

.BaseTable-module__p-16___iSc7_ {
  padding: 16px !important;
}

.BaseTable-module__p-30___yZOaB {
  padding: 30px !important;
}

.BaseTable-module__p-b-0___euhOm {
  padding-bottom: 0 !important;
}

.BaseTable-module__p-b-5___Mf2Yv {
  padding-bottom: 5px !important;
}

.BaseTable-module__p-b-10___BGlm2 {
  padding-bottom: 10px !important;
}

.BaseTable-module__p-b-12___D0G6Q {
  padding-bottom: 12px !important;
}

.BaseTable-module__p-b-16___s0p1h {
  padding-bottom: 16px !important;
}

.BaseTable-module__p-b-18___K8bYh {
  padding-bottom: 18px !important;
}

.BaseTable-module__p-b-20___Vopnp {
  padding-bottom: 20px !important;
}

.BaseTable-module__p-b-25___PDjaM {
  padding-bottom: 25px !important;
}

.BaseTable-module__p-b-30___N0h0Z {
  padding-bottom: 30px !important;
}

.BaseTable-module__p-b-50___QWSDI {
  padding-bottom: 50px !important;
}

.BaseTable-module__p-t-0___ovl3J {
  padding-top: 0 !important;
}

.BaseTable-module__p-t-12___z8grA {
  padding-top: 12px !important;
}

.BaseTable-module__p-t-16___tLjOB {
  padding-top: 16px !important;
}

.BaseTable-module__p-t-18___m8HF3 {
  padding-top: 18px !important;
}

.BaseTable-module__p-t-20___RVTH7 {
  padding-top: 20px !important;
}

.BaseTable-module__p-t-30___NGUFn {
  padding-top: 30px !important;
}

.BaseTable-module__p-t-40___BAvXa {
  padding-top: 40px !important;
}

.BaseTable-module__p-t-50___HOjsC {
  padding-top: 50px !important;
}

.BaseTable-module__p-l-20___r6rTh {
  padding-left: 20px !important;
}

.BaseTable-module__p-l-30___qekMB {
  padding-left: 30px !important;
}

.BaseTable-module__p-l-40___bQ5pR {
  padding-left: 40px !important;
}

.BaseTable-module__p-r-16___BG1Nt {
  padding-right: 16px !important;
}

.BaseTable-module__p-r-20___xGrmN {
  padding-right: 20px !important;
}

.BaseTable-module__p-r-30___XzTuX {
  padding-right: 30px !important;
}

.BaseTable-module__p-r-50___IFtBv {
  padding-right: 50px !important;
}

.BaseTable-module__p-r-60___JRkaf {
  padding-right: 60px !important;
}

.BaseTable-module__m-b-1___Zu4el {
  margin-bottom: 1px !important;
}

.BaseTable-module__m-b-2___Ci1wu {
  margin-bottom: 2px !important;
}

.BaseTable-module__m-b-6____4GJM {
  margin-bottom: 6px !important;
}

.BaseTable-module__m-b-8___iBRG4 {
  margin-bottom: 8px !important;
}

.BaseTable-module__m-b-10___WW_J9 {
  margin-bottom: 10px !important;
}

.BaseTable-module__m-b-14___NH3BN {
  margin-bottom: 14px !important;
}

.BaseTable-module__m-b-16___ULcCW {
  margin-bottom: 16px !important;
}

.BaseTable-module__m-b-20___sjfqB {
  margin-bottom: 20px !important;
}

.BaseTable-module__m-b-22___apTu2 {
  margin-bottom: 22px !important;
}

.BaseTable-module__m-b-24___s8FiU {
  margin-bottom: 24px !important;
}

.BaseTable-module__m-b-30___fL9Aw {
  margin-bottom: 30px !important;
}

.BaseTable-module__m-b-32___XeGyh {
  margin-bottom: 32px !important;
}

.BaseTable-module__m-b-40___hNK8O {
  margin-bottom: 40px !important;
}

.BaseTable-module__m-t-2___Pz35b {
  margin-top: 2px !important;
}

.BaseTable-module__m-t-3___uU1g_ {
  margin-top: 3px !important;
}

.BaseTable-module__m-t-4___pyFWK {
  margin-top: 4px !important;
}

.BaseTable-module__m-t-5___RGC_8 {
  margin-top: 5px !important;
}

.BaseTable-module__m-t-8___Iant_ {
  margin-top: 8px !important;
}

.BaseTable-module__m-t-10___sPsfh {
  margin-top: 10px !important;
}

.BaseTable-module__m-t-15___spPEd {
  margin-top: 15px !important;
}

.BaseTable-module__m-t-16___ocKn0 {
  margin-top: 16px !important;
}

.BaseTable-module__m-t-20____JoHe {
  margin-top: 20px !important;
}

.BaseTable-module__m-t-22___ZHKpF {
  margin-top: 22px !important;
}

.BaseTable-module__m-t-30___X6fx5 {
  margin-top: 30px !important;
}

.BaseTable-module__m-t-32___e1D0J {
  margin-top: 32px !important;
}

.BaseTable-module__m-l-auto___5AGJK {
  margin-left: auto !important;
}

.BaseTable-module__m-l-4___HM93L {
  margin-left: 4px !important;
}

.BaseTable-module__m-l-5___rq1G9 {
  margin-left: 5px !important;
}

.BaseTable-module__m-l-6___Bo1l2 {
  margin-left: 6px !important;
}

.BaseTable-module__m-l-8___cg0V3 {
  margin-left: 8px !important;
}

.BaseTable-module__m-l-10___sN2Vl {
  margin-left: 10px !important;
}

.BaseTable-module__m-l-16___Rjarf {
  margin-left: 16px !important;
}

.BaseTable-module__m-l-20___OwaK9 {
  margin-left: 20px !important;
}

.BaseTable-module__m-l-24___VfEtA {
  margin-left: 24px !important;
}

.BaseTable-module__m-l-30___zKUu_ {
  margin-left: 30px !important;
}

.BaseTable-module__m-l-35___U0TWO {
  margin-left: 35px !important;
}

.BaseTable-module__m-l-40___VBq2M {
  margin-left: 40px !important;
}

.BaseTable-module__m-r-8___CKdB6 {
  margin-right: 8px !important;
}

.BaseTable-module__m-r-10___lUEci {
  margin-right: 10px !important;
}

.BaseTable-module__m-r-16___X5PLT {
  margin-right: 16px !important;
}

.BaseTable-module__m-r-20___Mm5gD {
  margin-right: 20px !important;
}

.BaseTable-module__m-r-24___VqOTI {
  margin-right: 24px !important;
}

.BaseTable-module__m-r-30___OYwYi {
  margin-right: 30px !important;
}

.BaseTable-module__m-r-40___Jh8JV {
  margin-right: 40px !important;
}

.BaseTable-module__border-r-3___jO9dC {
  border-radius: 3px !important;
}

.BaseTable-module__border-r-4___GXr9A {
  border-radius: 4px !important;
}

.BaseTable-module__border-r-6___S0vnc {
  border-radius: 6px !important;
}

.BaseTable-module__border-r-10___pcu_V {
  border-radius: 10px !important;
}

.BaseTable-module__border-r-12___Z6U1Y {
  border-radius: 12px !important;
}

.BaseTable-module__border-r-16___VqtnL {
  border-radius: 16px !important;
}

.BaseTable-module__border-r-50___zW7g5 {
  border-radius: 50% !important;
}

.BaseTable-module__primary-border___l1Ltt {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BaseTable-module__primary-border-b___Xmi7k {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BaseTable-module__primary-border-t___jXPmH {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BaseTable-module__primary-border-l___hflxy {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BaseTable-module__primary-border-r___uD6ZJ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BaseTable-module__secondary-border___JK9PH {
  border: 1px solid #637768;
}

.BaseTable-module__secondary-border-b___ntXLG {
  border-bottom: 1px solid #637768;
}

.BaseTable-module__secondary-border-t___qmTun {
  border-top: 1px solid #637768;
}

.BaseTable-module__secondary-border-l___ql0kZ {
  border-left: 1px solid #637768;
}

.BaseTable-module__secondary-border-r___zFKln {
  border-right: 1px solid #637768;
}

.BaseTable-module__gap-0___gMGGy {
  gap: 0 !important;
}

.BaseTable-module__gap-2___rxMwE {
  gap: 2px !important;
}

.BaseTable-module__gap-4___zCGDz {
  gap: 4px !important;
}

.BaseTable-module__gap-5____x636 {
  gap: 5px !important;
}

.BaseTable-module__gap-6___Q7eL0 {
  gap: 6px !important;
}

.BaseTable-module__gap-8___W2RKK {
  gap: 8px !important;
}

.BaseTable-module__gap-10___xAXvX {
  gap: 10px !important;
}

.BaseTable-module__gap-12___HAnx7 {
  gap: 12px !important;
}

.BaseTable-module__gap-14___G8ErT {
  gap: 14px !important;
}

.BaseTable-module__gap-16___CiIDv {
  gap: 16px !important;
}

.BaseTable-module__gap-18___uBieU {
  gap: 18px !important;
}

.BaseTable-module__gap-20___b2K3P {
  gap: 20px !important;
}

.BaseTable-module__gap-24___ic6yA {
  gap: 24px !important;
}

.BaseTable-module__gap-26___oDKq6 {
  gap: 26px !important;
}

.BaseTable-module__gap-30___DEXHy {
  gap: 30px !important;
}

.BaseTable-module__gap-32___Vi5IP {
  gap: 32px !important;
}

.BaseTable-module__gap-40___s5BCC {
  gap: 40px !important;
}

.BaseTable-module__gap-50___fR1rr {
  gap: 50px !important;
}

.BaseTable-module__flex-1___JwP2e {
  flex: 1;
}

.BaseTable-module__flex-none___wNNfC {
  flex: none !important;
}

.BaseTable-module__flex-column___Jgiix {
  display: flex;
  flex-direction: column !important;
}

.BaseTable-module__flex-row___DX4QZ {
  display: flex;
  flex-direction: row !important;
}

.BaseTable-module__vertically-centered___Y0sKq {
  display: flex;
  align-items: center !important;
}

.BaseTable-module__horizontally-centered___SN6ZS {
  display: flex;
  justify-content: center !important;
}

.BaseTable-module__horizontally-end___be_4e {
  display: flex;
  justify-content: end !important;
}

.BaseTable-module__vertically-start___TJVUG {
  display: flex;
  align-items: start !important;
}

.BaseTable-module__space-between___f7YOC {
  display: flex;
  justify-content: space-between !important;
}

.BaseTable-module__flex-wrap___b0U5a {
  flex-wrap: wrap !important;
}

.BaseTable-module__height-100___r6bSf {
  height: 100%;
}

.BaseTable-module__width-50___PY2QE {
  width: 50% !important;
}

.BaseTable-module__width-100___M15sI {
  width: 100%;
}

.BaseTable-module__cursor-pointer___i2P8N {
  cursor: pointer;
}

.BaseTable-module__cursor-not-allowed___KJPq8 {
  cursor: not-allowed !important;
}

.BaseTable-module__absolute-centered___HAAkK {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BaseTable-module__absolute___hsTHE {
  position: absolute;
}

.BaseTable-module__relative___SXmMU {
  position: relative;
}

.BaseTable-module__fixed___uOE6m {
  position: fixed;
}

.BaseTable-module__visible___ZCF9R {
  opacity: 1;
}

.BaseTable-module__invisible___bIzNu {
  opacity: 0;
}

.BaseTable-module__col-90___LXU2r {
  width: 90% !important;
}

.BaseTable-module__col-auto___S00KQ {
  width: auto !important;
}

.BaseTable-module__medical-tabs___X6RAR {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BaseTable-module__medical-table-new___pXj9l {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BaseTable-module__medical-table-new___pXj9l:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BaseTable-module__medical-table-new___pXj9l::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BaseTable-module__medical-table-new___pXj9l::-webkit-scrollbar-track {
  display: none;
}
.BaseTable-module__medical-table-new___pXj9l.BaseTable-module__no-pagination___rN0_E {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BaseTable-module__medical-table-new___pXj9l.BaseTable-module__no-pagination___rN0_E:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BaseTable-module__medical-table-new___pXj9l.BaseTable-module__no-pagination___rN0_E::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BaseTable-module__medical-table-new___pXj9l.BaseTable-module__no-pagination___rN0_E::-webkit-scrollbar-track {
  display: none;
}

.BaseTable-module__medical-table-empty___N5K2y {
  padding: 14px 40px !important;
}

.BaseTable-module__icon-btn___MVzmd {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BaseTable-module__search-icon___O17XY {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BaseTable-module__disable-select___zbzLX {
  user-select: none;
}

.BaseTable-module__break-word___VMmZn {
  word-break: break-word;
}

.BaseTable-module__popup-clear-btn___Hm3IL {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BaseTable-module__scroll-m-b-20___zjMZy {
  scroll-margin-bottom: 20px;
}

.BaseTable-module__container___ongUl {
  width: 100%;
}
.BaseTable-module__container___ongUl .BaseTable-module__thead___b3emz {
  background-color: #fbf7f2;
  padding: 10px 40px;
}
.BaseTable-module__container___ongUl .BaseTable-module__thead___b3emz .BaseTable-module__tr___DmW9e {
  display: flex;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #375844;
  flex: 1;
}
.BaseTable-module__container___ongUl .BaseTable-module__thead___b3emz .BaseTable-module__tr___DmW9e .BaseTable-module__th___wkHNI {
  width: 200px;
  text-align: start;
  cursor: pointer;
}
.BaseTable-module__container___ongUl .BaseTable-module__thead___b3emz .BaseTable-module__tr___DmW9e .BaseTable-module__th___wkHNI .BaseTable-module__sortBtn___Ecsed {
  width: 10px;
  height: 10px;
  margin-left: 6px;
  transition: transform 0.4s ease;
}
.BaseTable-module__container___ongUl .BaseTable-module__tbody___YxpU9 {
  flex: 1;
}
.BaseTable-module__container___ongUl .BaseTable-module__tbody___YxpU9 .BaseTable-module__tr___DmW9e {
  display: flex;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #375844;
  flex: 1;
  padding: 10px 40px;
  align-items: center;
}
.BaseTable-module__container___ongUl .BaseTable-module__tbody___YxpU9 .BaseTable-module__tr___DmW9e .BaseTable-module__td___lZXa7 {
  width: 200px;
  text-align: start;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/BaseTable/BaseTable.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,kBAAA;AA8pBJ;AA5pBI;EACE,aAAA;EEgBJ,+BApBO;EAqBP,gBAFmD;EFb/C,iBAAA;EACA,cAAA;EACA,OAAA;AA+pBN;AA7pBM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;AA+pBR;AA7pBQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;AA+pBV;AAzpBE;EACE,OAAA;AA2pBJ;AAzpBI;EACE,aAAA;EETJ,+BApBO;EAqBP,gBAFmD;EFY/C,iBAAA;EACA,cAAA;EACA,OAAA;EACA,kBAAA;EACA,mBAAA;AA4pBN;AA1pBM;EACE,YAAA;EACA,iBAAA;AA4pBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  width: 100%;\n\n  .thead {\n    background-color: #fbf7f2;\n    padding: 10px 40px;\n\n    .tr {\n      display: flex;\n      @include get-font($roboto);\n      line-height: 150%;\n      color: get-color(greenNew, dark);\n      flex: 1;\n\n      .th {\n        width: 200px;\n        text-align: start;\n        cursor: pointer;\n\n        .sortBtn {\n          width: 10px;\n          height: 10px;\n          margin-left: 6px;\n          transition: transform 0.4s ease;\n        }\n      }\n    }\n  }\n\n  .tbody {\n    flex: 1;\n\n    .tr {\n      display: flex;\n      @include get-font($roboto);\n      line-height: 150%;\n      color: get-color(greenNew, dark);\n      flex: 1;\n      padding: 10px 40px;\n      align-items: center;\n\n      .td {\n        width: 200px;\n        text-align: start;\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BaseTable-module__font-s-10___xQLlf`,
	"fontS12": `BaseTable-module__font-s-12___PPO1E`,
	"fontS13": `BaseTable-module__font-s-13___iLU1R`,
	"fontS14": `BaseTable-module__font-s-14___aDOtc`,
	"fontS15": `BaseTable-module__font-s-15___rV_ly`,
	"fontS16": `BaseTable-module__font-s-16___AfkeJ`,
	"fontS18": `BaseTable-module__font-s-18___kN0Jj`,
	"fontS20": `BaseTable-module__font-s-20___cAnZi`,
	"fontS22": `BaseTable-module__font-s-22___VKqTB`,
	"fontS28": `BaseTable-module__font-s-28___bFhcm`,
	"fontW400": `BaseTable-module__font-w-400___y2ef6`,
	"fontW500": `BaseTable-module__font-w-500___QRuId`,
	"fontW600": `BaseTable-module__font-w-600___pdYsj`,
	"fontW700": `BaseTable-module__font-w-700___GHReb`,
	"p5": `BaseTable-module__p-5___uYjxR`,
	"p12": `BaseTable-module__p-12___hgcEg`,
	"p16": `BaseTable-module__p-16___iSc7_`,
	"p30": `BaseTable-module__p-30___yZOaB`,
	"pB0": `BaseTable-module__p-b-0___euhOm`,
	"pB5": `BaseTable-module__p-b-5___Mf2Yv`,
	"pB10": `BaseTable-module__p-b-10___BGlm2`,
	"pB12": `BaseTable-module__p-b-12___D0G6Q`,
	"pB16": `BaseTable-module__p-b-16___s0p1h`,
	"pB18": `BaseTable-module__p-b-18___K8bYh`,
	"pB20": `BaseTable-module__p-b-20___Vopnp`,
	"pB25": `BaseTable-module__p-b-25___PDjaM`,
	"pB30": `BaseTable-module__p-b-30___N0h0Z`,
	"pB50": `BaseTable-module__p-b-50___QWSDI`,
	"pT0": `BaseTable-module__p-t-0___ovl3J`,
	"pT12": `BaseTable-module__p-t-12___z8grA`,
	"pT16": `BaseTable-module__p-t-16___tLjOB`,
	"pT18": `BaseTable-module__p-t-18___m8HF3`,
	"pT20": `BaseTable-module__p-t-20___RVTH7`,
	"pT30": `BaseTable-module__p-t-30___NGUFn`,
	"pT40": `BaseTable-module__p-t-40___BAvXa`,
	"pT50": `BaseTable-module__p-t-50___HOjsC`,
	"pL20": `BaseTable-module__p-l-20___r6rTh`,
	"pL30": `BaseTable-module__p-l-30___qekMB`,
	"pL40": `BaseTable-module__p-l-40___bQ5pR`,
	"pR16": `BaseTable-module__p-r-16___BG1Nt`,
	"pR20": `BaseTable-module__p-r-20___xGrmN`,
	"pR30": `BaseTable-module__p-r-30___XzTuX`,
	"pR50": `BaseTable-module__p-r-50___IFtBv`,
	"pR60": `BaseTable-module__p-r-60___JRkaf`,
	"mB1": `BaseTable-module__m-b-1___Zu4el`,
	"mB2": `BaseTable-module__m-b-2___Ci1wu`,
	"mB6": `BaseTable-module__m-b-6____4GJM`,
	"mB8": `BaseTable-module__m-b-8___iBRG4`,
	"mB10": `BaseTable-module__m-b-10___WW_J9`,
	"mB14": `BaseTable-module__m-b-14___NH3BN`,
	"mB16": `BaseTable-module__m-b-16___ULcCW`,
	"mB20": `BaseTable-module__m-b-20___sjfqB`,
	"mB22": `BaseTable-module__m-b-22___apTu2`,
	"mB24": `BaseTable-module__m-b-24___s8FiU`,
	"mB30": `BaseTable-module__m-b-30___fL9Aw`,
	"mB32": `BaseTable-module__m-b-32___XeGyh`,
	"mB40": `BaseTable-module__m-b-40___hNK8O`,
	"mT2": `BaseTable-module__m-t-2___Pz35b`,
	"mT3": `BaseTable-module__m-t-3___uU1g_`,
	"mT4": `BaseTable-module__m-t-4___pyFWK`,
	"mT5": `BaseTable-module__m-t-5___RGC_8`,
	"mT8": `BaseTable-module__m-t-8___Iant_`,
	"mT10": `BaseTable-module__m-t-10___sPsfh`,
	"mT15": `BaseTable-module__m-t-15___spPEd`,
	"mT16": `BaseTable-module__m-t-16___ocKn0`,
	"mT20": `BaseTable-module__m-t-20____JoHe`,
	"mT22": `BaseTable-module__m-t-22___ZHKpF`,
	"mT30": `BaseTable-module__m-t-30___X6fx5`,
	"mT32": `BaseTable-module__m-t-32___e1D0J`,
	"mLAuto": `BaseTable-module__m-l-auto___5AGJK`,
	"mL4": `BaseTable-module__m-l-4___HM93L`,
	"mL5": `BaseTable-module__m-l-5___rq1G9`,
	"mL6": `BaseTable-module__m-l-6___Bo1l2`,
	"mL8": `BaseTable-module__m-l-8___cg0V3`,
	"mL10": `BaseTable-module__m-l-10___sN2Vl`,
	"mL16": `BaseTable-module__m-l-16___Rjarf`,
	"mL20": `BaseTable-module__m-l-20___OwaK9`,
	"mL24": `BaseTable-module__m-l-24___VfEtA`,
	"mL30": `BaseTable-module__m-l-30___zKUu_`,
	"mL35": `BaseTable-module__m-l-35___U0TWO`,
	"mL40": `BaseTable-module__m-l-40___VBq2M`,
	"mR8": `BaseTable-module__m-r-8___CKdB6`,
	"mR10": `BaseTable-module__m-r-10___lUEci`,
	"mR16": `BaseTable-module__m-r-16___X5PLT`,
	"mR20": `BaseTable-module__m-r-20___Mm5gD`,
	"mR24": `BaseTable-module__m-r-24___VqOTI`,
	"mR30": `BaseTable-module__m-r-30___OYwYi`,
	"mR40": `BaseTable-module__m-r-40___Jh8JV`,
	"borderR3": `BaseTable-module__border-r-3___jO9dC`,
	"borderR4": `BaseTable-module__border-r-4___GXr9A`,
	"borderR6": `BaseTable-module__border-r-6___S0vnc`,
	"borderR10": `BaseTable-module__border-r-10___pcu_V`,
	"borderR12": `BaseTable-module__border-r-12___Z6U1Y`,
	"borderR16": `BaseTable-module__border-r-16___VqtnL`,
	"borderR50": `BaseTable-module__border-r-50___zW7g5`,
	"primaryBorder": `BaseTable-module__primary-border___l1Ltt`,
	"primaryBorderB": `BaseTable-module__primary-border-b___Xmi7k`,
	"primaryBorderT": `BaseTable-module__primary-border-t___jXPmH`,
	"primaryBorderL": `BaseTable-module__primary-border-l___hflxy`,
	"primaryBorderR": `BaseTable-module__primary-border-r___uD6ZJ`,
	"secondaryBorder": `BaseTable-module__secondary-border___JK9PH`,
	"secondaryBorderB": `BaseTable-module__secondary-border-b___ntXLG`,
	"secondaryBorderT": `BaseTable-module__secondary-border-t___qmTun`,
	"secondaryBorderL": `BaseTable-module__secondary-border-l___ql0kZ`,
	"secondaryBorderR": `BaseTable-module__secondary-border-r___zFKln`,
	"gap0": `BaseTable-module__gap-0___gMGGy`,
	"gap2": `BaseTable-module__gap-2___rxMwE`,
	"gap4": `BaseTable-module__gap-4___zCGDz`,
	"gap5": `BaseTable-module__gap-5____x636`,
	"gap6": `BaseTable-module__gap-6___Q7eL0`,
	"gap8": `BaseTable-module__gap-8___W2RKK`,
	"gap10": `BaseTable-module__gap-10___xAXvX`,
	"gap12": `BaseTable-module__gap-12___HAnx7`,
	"gap14": `BaseTable-module__gap-14___G8ErT`,
	"gap16": `BaseTable-module__gap-16___CiIDv`,
	"gap18": `BaseTable-module__gap-18___uBieU`,
	"gap20": `BaseTable-module__gap-20___b2K3P`,
	"gap24": `BaseTable-module__gap-24___ic6yA`,
	"gap26": `BaseTable-module__gap-26___oDKq6`,
	"gap30": `BaseTable-module__gap-30___DEXHy`,
	"gap32": `BaseTable-module__gap-32___Vi5IP`,
	"gap40": `BaseTable-module__gap-40___s5BCC`,
	"gap50": `BaseTable-module__gap-50___fR1rr`,
	"flex1": `BaseTable-module__flex-1___JwP2e`,
	"flexNone": `BaseTable-module__flex-none___wNNfC`,
	"flexColumn": `BaseTable-module__flex-column___Jgiix`,
	"flexRow": `BaseTable-module__flex-row___DX4QZ`,
	"verticallyCentered": `BaseTable-module__vertically-centered___Y0sKq`,
	"horizontallyCentered": `BaseTable-module__horizontally-centered___SN6ZS`,
	"horizontallyEnd": `BaseTable-module__horizontally-end___be_4e`,
	"verticallyStart": `BaseTable-module__vertically-start___TJVUG`,
	"spaceBetween": `BaseTable-module__space-between___f7YOC`,
	"flexWrap": `BaseTable-module__flex-wrap___b0U5a`,
	"height100": `BaseTable-module__height-100___r6bSf`,
	"width50": `BaseTable-module__width-50___PY2QE`,
	"width100": `BaseTable-module__width-100___M15sI`,
	"cursorPointer": `BaseTable-module__cursor-pointer___i2P8N`,
	"cursorNotAllowed": `BaseTable-module__cursor-not-allowed___KJPq8`,
	"absoluteCentered": `BaseTable-module__absolute-centered___HAAkK`,
	"absolute": `BaseTable-module__absolute___hsTHE`,
	"relative": `BaseTable-module__relative___SXmMU`,
	"fixed": `BaseTable-module__fixed___uOE6m`,
	"visible": `BaseTable-module__visible___ZCF9R`,
	"invisible": `BaseTable-module__invisible___bIzNu`,
	"col90": `BaseTable-module__col-90___LXU2r`,
	"colAuto": `BaseTable-module__col-auto___S00KQ`,
	"medicalTabs": `BaseTable-module__medical-tabs___X6RAR`,
	"medicalTableNew": `BaseTable-module__medical-table-new___pXj9l`,
	"noPagination": `BaseTable-module__no-pagination___rN0_E`,
	"medicalTableEmpty": `BaseTable-module__medical-table-empty___N5K2y`,
	"iconBtn": `BaseTable-module__icon-btn___MVzmd`,
	"searchIcon": `BaseTable-module__search-icon___O17XY`,
	"disableSelect": `BaseTable-module__disable-select___zbzLX`,
	"breakWord": `BaseTable-module__break-word___VMmZn`,
	"popupClearBtn": `BaseTable-module__popup-clear-btn___Hm3IL`,
	"scrollMB20": `BaseTable-module__scroll-m-b-20___zjMZy`,
	"container": `BaseTable-module__container___ongUl`,
	"thead": `BaseTable-module__thead___b3emz`,
	"tr": `BaseTable-module__tr___DmW9e`,
	"th": `BaseTable-module__th___wkHNI`,
	"sortBtn": `BaseTable-module__sortBtn___Ecsed`,
	"tbody": `BaseTable-module__tbody___YxpU9`,
	"td": `BaseTable-module__td___lZXa7`
};
module.exports = ___CSS_LOADER_EXPORT___;
